import { baseApi } from './baseApi';

const toQuery = (filter = {}) => {
  const p = new URLSearchParams();
  Object.entries(filter).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') p.append(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : '';
};

export const communicationsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    listTemplates: build.query({
      query: () => '/templates',
      transformResponse: (resp) => resp.data,
      providesTags: ['Template'],
    }),
    createTemplate: build.mutation({
      query: (body) => ({ url: '/templates', method: 'POST', body }),
      transformResponse: (resp) => resp.data,
      invalidatesTags: ['Template'],
    }),
    updateTemplate: build.mutation({
      query: ({ id, ...body }) => ({ url: `/templates/${id}`, method: 'PUT', body }),
      transformResponse: (resp) => resp.data,
      invalidatesTags: ['Template'],
    }),
    deleteTemplate: build.mutation({
      query: (id) => ({ url: `/templates/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Template'],
    }),
    listMessages: build.query({
      query: (filter) => `/messages${toQuery(filter)}`,
      transformResponse: (resp) => resp.data,
      providesTags: ['Message'],
    }),
    // Date-ranged send/delivery/failure summary — the Reports "Communication" tab's KPI + chart data.
    getMessageAnalytics: build.query({
      query: (filter) => `/messages/analytics${toQuery(filter)}`,
      transformResponse: (resp) => resp.data,
      providesTags: ['Message'],
    }),
    sendMessage: build.mutation({
      query: (body) => ({ url: '/messages/send', method: 'POST', body }),
      transformResponse: (resp) => resp.data,
      invalidatesTags: ['Message'],
    }),
    // Sends the real appointment_reminder WhatsApp template to every patient Scheduled today (IST).
    // Idempotent server-side — already-sent reminders for today are skipped, safe to click more than once.
    sendDueReminders: build.mutation({
      query: () => ({ url: '/messages/reminders/send-due', method: 'POST' }),
      transformResponse: (resp) => resp.data,
      invalidatesTags: ['Message'],
    }),
    // Reflects the server's MetaCloudOptions.Paused flag — the same one every WhatsApp sender
    // checks before sending, so the "Under maintenance" banner can never drift out of sync.
    getWhatsAppStatus: build.query({
      query: () => '/messages/whatsapp-status',
      transformResponse: (resp) => resp.data,
      providesTags: ['WhatsAppStatus'],
    }),
  }),
});

export const {
  useListTemplatesQuery, useCreateTemplateMutation, useUpdateTemplateMutation, useDeleteTemplateMutation,
  useListMessagesQuery, useLazyListMessagesQuery, useSendMessageMutation,
  useGetMessageAnalyticsQuery,
  useSendDueRemindersMutation,
  useGetWhatsAppStatusQuery,
} = communicationsApi;
